import auth0 from 'auth0-js';
import EventEmitter from 'eventemitter3';
import router from '../router';
import store from '../store';

import axios from 'axios';

const axiosServer = axios.create({
  baseURL: store.getters.getBackendIpAddress,
});

import Vue from 'vue';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

Vue.$cookies.config('7d');

export default class AuthService {
  // authenticated = this.isAuthenticated()
  authNotifier = new EventEmitter();

  auth0 = new auth0.WebAuth({
    domain: "https://authentication.aquaop.ca",
    clientID: store.getters.getAuthenticationClientID,
    responseType: 'token',
    // responseMode: 'form_post',
    audience: store.getters.getAuthenticationAudience,
    scope: 'openid profile',
  });

  login(username, password) {
    this.auth0.login(
      {
        realm: store.getters.getAuthenticationRealm,
        username: username,
        password: password,
        redirectUri: store.getters.getFrontendIpAddress + '/callback',
      },
      function(err) {
        console.log('error:::: ', err);
        if (err.error === "access_denied") {
         store.dispatch("setMessage", {
          active: true,
          description: err.description || "Invalid username or password",
          type: "error",
         });
        }
      }
    );
  }

  handleAuthentication() {
    this.auth0.parseHash((err, authResult) => {
      if (err) {
        console.log(err);
        store.dispatch('setMessage', {
          active: true,
          description: 'Login Issue, Please Try Again',
          type: 'error',
        });
        router.replace('/');
      } else {
        if (authResult && authResult.accessToken) {
          axiosServer
            .get('/general/authorization/login', {
              headers: {
                Authorization: 'Bearer ' + authResult.accessToken,
              },
            })
            .then((res) => {
              this.setSession(authResult);
              Vue.$cookies.set('accessToken', JSON.stringify(authResult));
              this.handleSuccessfulLogin(res.data);
            })
            .catch((e) => {
              console.log('error:::', e, e.response);
              store.dispatch('setMessage', {
                active: true,
                description: e.response.data,
                type: 'error',
              });
              router.replace('/');
            });
        } else if (err) {
          router.replace('/');
          console.log(err);
        }
      }
    });
  }

  handleSuccessfulLogin(data) {
    store.dispatch('setUserInfo', data.user);
    store.dispatch('isSetupComplete', data.is_setup_complete);

    Vue.$cookies.set('userInfo', JSON.stringify(data.user));

    //check if user and company are disabled
    if (!data.is_user_company_active) {
      store.dispatch('setMessage', {
        active: true,
        description:
          'Your plan is inactive. Please contact Wittaya Aqua for assistance',
        type: 'error',
      });
      router.replace('/');
    }
    //check if setup complete (country selection)
    else if (!data.is_setup_complete) {
      //if farm owner, go to company setup
      if (data.user.role_level >= 3) {
        router.replace('/companySetup');
      }
      //if role < farm owner, then can't log in
      else {
        store.dispatch('setMessage', {
          active: true,
          description:
            'Please wait until the farm owner completes the company setup before trying to log in',
          type: 'error',
        });
        router.replace('/');
      }
    } else {
      router.replace('/homePage');
    }
  }

  setSession(authResult) {
    // Set the time that the Access Token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    );
    store.dispatch('setAuthResult', authResult);
    // this.authNotifier.emit('authChange', {
    //     authenticated: true
    // })
  }

  logout() {
    // Clear Access Token and ID Token from local storage

    this.userProfile = null;
    this.authNotifier.emit('authChange', false);
    // navigate to the home route
    router.replace('home');
  }

  resetPassword(email) {
    this.auth0.changePassword(
      {
        connection: store.getters.getAuthenticationRealm,
        email: email,
      },
      function(err, resp) {
        if (err) {
          console.log(err.message);
        } else {
          store.dispatch('setMessage', {
            active: true,
            description: 'Password Reset Sent, Please Check your Email',
            type: 'success',
          });
        }
      }
    );
  }
}
